import { RootState } from '../../app/store'

export const selectIsSendingEmail = (state: RootState) => state.emails.isSending
export const selectIsEmailSuccess = (state: RootState) => state.emails.isSuccess
export const selectEmailError = (state: RootState) => state.emails.error
export const selectLastEmailId = (state: RootState) => state.emails.lastEmailId
